@use '../@shared/mixins' as *;
@use '../../styles/global' as *;

@layer kol-component {
	.kol-quote {
		$root: &;
		display: inline;
		margin: 0;
		padding: 0;

		&__cite {
			&::before {
				@at-root #{$root}--block & {
					padding-right: 0.5em;
				}

				@at-root #{$root}--inline & {
					padding: 0.5em;
				}
				content: '—';
			}
		}

		&__figcaption {
			@at-root #{$root}--block & {
				display: inline;
				margin: 0;
				padding: 0;
			}
		}

		&__blockquote {
			&::before {
				content: open-quote;
			}

			&::after {
				content: close-quote;
			}
		}
	}
}
